import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import img_gestion_catalogue_1 from "../../images/presentation/gestion_catalogue_1.jpg"
import img_alerte_poche_1 from "../../images/presentation/alerte_poche_1.png"
import img_actualisation_referencement_1 from "../../images/presentation/actualisation_referencement_1.jpg"
//import img_data_control_1 from "../../images/presentation/data_control_1.png"
import img_data_control_sablier from "../../images/presentation/data_control_visuel_sablier_sur_grille.png"
import img_data_expert_1 from "../../images/presentation/data_expert_1.jpg"
import img_achat_fichiers_1 from "../../images/presentation/achat_fichiers_1.png"

import { Modules, ModulesIds } from "../../config/helpers";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import CpntAccueilModule from "./components/CpntAccueilModule";

const PageAccueil = () => {

  const compte = useSelector((state: RootState) => state.compte);

  //console.log(compte?.Modules,compte?.Modules?.find(mid => mid === ModulesIds.ReferencementElectre));
  
  useEffect(() => {
    localStorage.removeItem("IFilterNotices");
    localStorage.removeItem("IFilterSocietes");
    localStorage.removeItem("IFilterComptes");
    localStorage.removeItem("IFilterMessagesNotices");
    localStorage.removeItem("IFilterMessagesMarques");
    localStorage.removeItem("IFilterNoticesDemandesNotices");
    localStorage.removeItem("IFilterComptesBO");  
    localStorage.removeItem("IFilterSocietesBO");
    localStorage.removeItem("IFilterDemandes");
    localStorage.removeItem("IFilterInscriptions");
    localStorage.removeItem("IFilterFichierAlertePoches");
    localStorage.removeItem("ISortStore");
    localStorage.removeItem("IFilterNoticesAapraitre");
    
    localStorage.removeItem("ISortStore");
    localStorage.removeItem("NoticesNavigator");
    localStorage.removeItem("IFilterMarques");
    localStorage.removeItem("IFilterMarquesSearch");
    localStorage.removeItem("IFilterActeursJuridiquesSearch");
    localStorage.removeItem("MarquesNavigator");
    localStorage.removeItem("activeTab");
  }, []);

   return (
    <>
    <div className="container text-center">
        <div className="row pt-2 pb-2">
        <div className="col col-md-10 offset-md-1 col-12  ">
        <div className="titre text-center">Bienvenue dans votre espace {process.env.REACT_APP_WEBSITE_TITLE}</div>
        </div>
        </div>
        {/* <div className="row pt-3 pb-2">
          <div className="col col-md-10 offset-md-1 col-12 ">
            <div className="description">
            </div>
          </div>
      </div> */}
    </div>
      <Row xs={1} md={2} className="mt-1 g-4">
        <Col key={1}>
        <CpntAccueilModule 
        title={Modules.GestionDeVotreCatalogue}
        boostrapiconClassname="bi-book"
        description={( <ul>
          <li>Accédez gratuitement à l&apos;intégralité des ouvrages de votre catalogue référencés dans la base de données Electre</li>
          <li>Profitez d&apos;une interface d&apos;échanges avec les experts du catalogage d&apos;Electre pour assurer la qualité de vos données</li>
        </ul>)}
        illustration={img_gestion_catalogue_1}
        btnAccesAvailable={compte?.Modules?.find(mid => mid === ModulesIds.ReferencementElectre)!==undefined} //check ?
        btnAccesPath="/espaceediteur"
        btnInfoAvailable={compte?.Modules?.find(mid => mid === ModulesIds.ReferencementElectre)===undefined}
        btnInfoPath="/gestion-catalogue"
        />
      </Col>
        <Col key={2}>
      <CpntAccueilModule 
        title={Modules.ElectreDataControl}
        boostrapiconClassname="bi-hourglass-split"
        description={( <ul>
          <li>Vérifiez, comparez, et analysez en un coup d&apos;œil la qualité de vos données sur les neuf principales plateformes de vente en ligne.</li>
        </ul>)}
        illustration={img_data_control_sablier}
        //btnAccesAvailable={compte?.Modules?.find(mid => mid === ModulesIds.ElectreDataControl)!==undefined} //check ?
        btnInfoAvailable={true}
        btnInfoPath="/data-control"
        />
      </Col>
      <Col key={3}>
      <CpntAccueilModule 
        title={Modules.AlertePoche}
        boostrapiconClassname="bi-bell"
        description={( <ul>
          <li>Bénéficiez d&apos;un rapport mensuel pour suivre l&apos;évolution des ouvrages de votre catalogue publiés au format poche</li>
        </ul>)}
        illustration={img_alerte_poche_1}
        btnAccesAvailable={compte?.Modules?.find(mid => mid === ModulesIds.AlertePoche)!==undefined} //check ?
        btnAccesPath="/alertepoche"
        btnInfoAvailable={compte?.Modules?.find(mid => mid === ModulesIds.AlertePoche)===undefined}
        btnInfoPath="/alerte-poche"
        />
        </Col>
      <Col key={4}>
      <CpntAccueilModule 
        title={Modules.ElectreDataExpert}
        boostrapiconClassname="bi-eyeglasses"
        description={( <ul>
          <li>Prenez la main sur vos données éditoriales !</li>
          <li>Fiabilisez votre processus et augmentez votre visibilité dans tous les canaux de diffusion</li>
          <li>Electre vous propose un audit de votre fonds afin de gagner en qualité et efficacité</li>
        </ul>)}
        illustration={img_data_expert_1}
        //btnAccesAvailable={compte?.Modules?.find(mid => mid === ModulesIds.ElectreDataExpert)!==undefined} //check ?
        btnInfoAvailable={true}
        btnInfoPath="/data-expert"
        />
      </Col>
       <Col key={5}>
        <CpntAccueilModule 
        title={Modules.ActualisationDuReferencement}
        boostrapiconClassname="bi-arrow-clockwise"
        description={( <ul>
          <li>Demandez à Electre de réviser vos notices les plus anciennes pour les optimiser et bénéficier ainsi d&apos;un meilleur référencement</li>
        </ul>)}
        illustration={img_actualisation_referencement_1}
        //btnAccesAvailable={compte?.Modules?.find(mid => mid === ModulesIds.ElectreDataControl)!==undefined} //check ?
        btnInfoAvailable={true}
        btnInfoPath="/actualisation-referencement"
        />
        </Col>
        <Col key={6}>
        <CpntAccueilModule 
        title={Modules.AchatDeFichiers}
        boostrapiconClassname="bi-file-earmark-zip"
        description={( <ul>
          <li>Trouvez tous les fichiers utiles à votre veille stratégique, votre projet éditorial ou une analyse commerciale</li>
          <li>Electre vous fournit les données dans un format prêt à l&apos;emploi</li>
        </ul>)}
        illustration={img_achat_fichiers_1}
        //btnAccesAvailable={compte?.Modules?.find(mid => mid === ModulesIds.ElectreDataControl)!==undefined} //check ?
        btnInfoAvailable={true}
        btnInfoPath="/achat-fichier"
        />
        </Col>
    </Row>

    </>
  );
};

export default PageAccueil;
